import EpgConstants from './EpgConstants';
import { EPGUtil } from "../Nepg/EPGUtil";
import settings from '../../devices/all/settings';

class ChannelList {
  constructor() {
    // this.filterController = filterController;
    this.quantity = EpgConstants.TOTAL_ROWS_CHANNEL_GRID;
    this.list = [];
    this.currentChannels = [];
    this.currentIndex = 0;
    this.eventUp;
    this.eventDown;
    this.lastIdxFromList = 0;
    this.functionPaint;
    this.redrawGridCallback;
    this.gridOpacityCallback;
    this.currentFilter =  null;
    this.focus =  null;
  }

  setRedraw(callback) {
    this.redrawGridCallback = callback;
  }


  setFocus(callback) {
    this.focus = callback;
  }

  setCurrentFilter(filter) {
    this.currentFilter = filter;
  }


  getCurrentFilter() {
    return this.currentFilter;
  }

  setGridOpacity(callback) {
    this.gridOpacityCallback = callback;
  }


  /**
   *
   *
   * @param {*} functionPaint Función que viene de ChannelController.
   * @memberof ChannelList
   */
  setPaintChannels(functionPaint) {
    this.functionPaint = functionPaint;
  }

  /**
   *
   *
   * @returns Array de groupId's que contiene el listado de canales pintados.
   * @memberof ChannelList
   */
  getCurrentChannels() {
    return this.currentChannels;
  }
  /**
   *
   *
   * @param {*} functionFocus Function que controla el foco de ChannelController hacia arriba
   * @memberof ChannelList
   */
  setEventUp(functionFocus) {
    this.eventUp = functionFocus;
  }
  /**
   *
   *
   * @param {*} functionFocus Funcion que controla el foco de ChannelController hacia abajo
   * @memberof ChannelList
   */
  setEventDown(functionFocus) {
    this.eventDown = functionFocus;
  }
  /**
   *
   *
   * @param {*} index
   * @memberof ChannelList Funcion que setea el indice actual
   */
  setCurrentIndex(index) {
    this.currentIndex = index;
  }
  /**
   *
   *
   * @returns
   * @memberof ChannelList Funciona que obtiene el indice actual
   */
  getCurrentIndex() {
    return this.currentIndex;
  }
  /**
   *
   *
   * @returns
   * @memberof ChannelList Funcion que obtiene el siguiente indice y pinta los siguientes canales hacia abajo.
   */
  downIndex(repeats = false) {
    if (this.currentIndex == this.quantity - 1) {
      this.currentIndex = this.quantity - 1;
      this.getNexChannelsDown(repeats);
      if(!repeats){
        this._collectorKey();
        // this.redrawGridCallback(this.currentChannels);
      }
    } else {
      this.currentIndex++;
    }
    return this.currentIndex;
  }



  downIndexNew(repeats = false) {
    if (this.currentIndex == this.quantity - 1) {
      this.currentIndex = 0;
      this.getNexChannelsDownNew(repeats);

    } else {
      this.currentIndex++;
    }
    return this.currentIndex;
  }



  /**
   *
   *
   * @returns
   * @memberof ChannelList  Funcion que obtiene el siguiente indice y pinta los siguientes canales hacia arriba.
   */
  upIndexNew(repeats = false) {
    if (this.currentIndex <= 0) {
      this.currentIndex = EpgConstants.TOTAL_ROWS_CHANNEL_GRID-1;
      this.getNexChannelsUpNew(repeats);
      // if(!repeats){
      //   this._collectorKey();
      //   // this.redrawGridCallback(this.currentChannels);
      // }
    } else {
      this.currentIndex--;
    }
    return this.currentIndex;
  }


  /**
   *
   *
   * @memberof ChannelList Funcion que obtiene los siguiente canales hacia arriba y los pinta.
   */
  getNexChannelsUpNew(repeats = false) {
    // Obteniendo el ultimo groupID
    const lastItem = this.currentChannels[0];
    const idx = this.getChannelIdxByGroupId(lastItem);
    this.currentChannels = this.getDataFromArrayAscNew(idx);
    if(settings.enable_epg_syc == false || repeats == true){
      this.functionPaint(this.currentChannels);
    }
    this.redrawGridCallback(this.currentChannels);
  }


  /**
   *
   *
   * @param {*} idx indice desde donde iniciara la iteracion de manera ascendente.
   * @returns Array de canales de manera ascendente apartir de un indice.
   * @memberof ChannelList
   */
  getDataFromArrayAscNew(idx) {
    let resp = [];
    while (resp.length <= this.quantity - 1) {
      if (idx == 0) {
        idx = this.list.length - 1;
        resp.push(this.list[idx]);
        idx--;
      } else {
        idx--;
        resp.push(this.list[idx]);
      }
    }
    return resp.reverse();
  }

  /**
   *
   *
   * @returns
   * @memberof ChannelList  Funcion que obtiene el siguiente indice y pinta los siguientes canales hacia arriba.
   */
  upIndex(repeats = false) {
    if (this.currentIndex <= 0) {
      this.currentIndex = 0;
      this.getNexChannelsUp(repeats);
      if(!repeats){
        this._collectorKey();
        // this.redrawGridCallback(this.currentChannels);
      }
    } else {
      this.currentIndex--;
    }
    return this.currentIndex;
  }


  _collectorKey(){
    // this.gridOpacityCallback(EpgConstants.OPACITY_GRID);
    clearTimeout(this.pressTimer);
    this.pressTimer = setTimeout( () => {
      this.redrawGridCallback(this.currentChannels);
    }, 10);
  }

  /**
   *
   *
   * @param {*} channelList Listado de canales donde se hará iteración
   * @memberof ChannelList Setea el listado de canales actuales
   */
  setChannelList(channelList) {
    this.list = channelList;
  }
  /**
   *
   *
   * @param {*} [loadObject=null] groupId desde donde se tomara el listado de canales.
   * @memberof ChannelList Funcion que setea inicialmente los canales a pintar.
   */
  setArrayInitFromGroupID(loadObject = null) {
    //Primero Obtenermos los canales
    this.updateChannelsFromFilter(this.getCurrentFilter()).then(()=>{
      let idx = this.getChannelIdxByGroupId(loadObject);
      this.currentChannels = this.getDataFromArrayDesc(idx);
      if(!settings.enable_epg_syc){
        this.functionPaint(this.currentChannels);
      }
      this.redrawGridCallback(this.currentChannels);
      this.focus(0);
    });
  }


  setArrayInitFromGroupIdTimeOut(groupId = null) {
    //Primero Obtenermos los canales
    this.updateChannelsFromFilter(this.getCurrentFilter()).then(()=>{
      let idx = this.getChannelIdxByGroupId(groupId);
      this.currentChannels = this.getDataFromArrayDesc(idx);
      this.functionPaint(this.currentChannels);
      this._collectorKeyFilter()
    });
  }


  _collectorKeyFilter(){
    this.gridOpacityCallback(EpgConstants.ACTIONS_LOADING.OPACITY);
    clearTimeout(this.pressTimer);
    this.pressTimer = setTimeout( () => {
      this.redrawGridCallback(this.currentChannels);
      this.focus(0);
    }, 400);
  }






  /**
   *
   *
   * @param {*} [groupId=null] groupId desde donde se tomara el listado de canales.
   * @memberof ChannelList Funcion que setea inicialmente los canales a pintar.
   */
  updateChannelsFilters(groupId = null) {
    // Se actuliza la lista de canalaes desde un filtro
    this.updateChannelsFromFilter(this.getCurrentFilter()).then(()=>{
      let idx = this.getChannelIdxByGroupId(groupId);
      this.currentChannels = this.getDataFromArrayDesc(idx);
      // Se pintan los canales
      this.functionPaint(this.currentChannels);
      // Se pone el foco en el primer canal
      this.focus(0);
    });
  }

  updateChannelsFromFilter(nodeID){
    return new Promise((resolve, reject) =>{
      EPGUtil.getChannelsByFilterId(nodeID).then((channels)=>{
        this.currentIndex = 0;
        this.list = channels;
        resolve();
      })
    });
  }

  /**
   *
   *
   * @memberof ChannelList Funcion que obtiene los siguiente canales hacia abajo y los pinta.
   */
  getNexChannelsDownNew(repeats = false) {
    // Obteniendo el ultimo groupID
    const lastItem = this.currentChannels[this.currentChannels.length-1];
    const idx = this.getChannelIdxByGroupId(lastItem);
    this.currentChannels = this.getDataFromArrayDescNew(idx+1);
    if(settings.enable_epg_syc == false || repeats == true){
      this.functionPaint(this.currentChannels);
    }
    this.redrawGridCallback(this.currentChannels);
  }

  /**
   *
   *
   * @memberof ChannelList Funcion que obtiene los siguiente canales hacia abajo y los pinta.
   */
  getNexChannelsDown(repeats = false) {
    // Obteniendo el ultimo groupID
    if(this.list.length <= EpgConstants.TOTAL_ROWS_CHANNEL_GRID) return;

    const lastItem = this.currentChannels[1];
    const idx = this.getChannelIdxByGroupId(lastItem);
    this.currentChannels = this.getDataFromArrayDesc(idx);
    if(settings.enable_epg_syc == false || repeats == true){
      this.functionPaint(this.currentChannels);
    }
  }

  /**
   *
   *
   * @memberof ChannelList Funcion que obtiene los siguiente canales hacia arriba y los pinta.
   */
  getNexChannelsUp(repeats = false) {
    // Obteniendo el ultimo groupID
    if(this.list.length <= EpgConstants.TOTAL_ROWS_CHANNEL_GRID) return;

    const lastItem = this.currentChannels[this.currentChannels.length - 2];
    const idx = this.getChannelIdxByGroupId(lastItem);
    this.currentChannels = this.getDataFromArrayAsc(idx);
    if(settings.enable_epg_syc == false || repeats == true){
      this.functionPaint(this.currentChannels);
    }
  }
  /**
   *
   *
   * @param {*} idx indice desde donde iniciara la iteracion de manera ascendente.
   * @returns Array de canales de manera ascendente apartir de un indice.
   * @memberof ChannelList
   */
  getDataFromArrayAsc(idx) {
    let resp = [];
    // agregando el primer elemento
    resp.push(this.list[idx]);
    // agregando el resto de elementos
    while (resp.length <= this.quantity - 1) {
      if (idx == 0) {
        idx = this.list.length - 1;
      } else {
        idx--;
      }
      resp.push(this.list[idx]);
    }
    return resp.reverse();
  }



  /**
   *
   *
   * @param {*} idx indice desde donde iniciara la iteracion de manera descendente.
   * @returns Array de canales de manera descendente apartir de un indice.
   * @memberof ChannelList
   */
  getDataFromArrayDescNew(idx) {
    let resp = [];
    // agregando el primer elemento
    // agregando el resto de elementos
    while (resp.length <= this.quantity - 1) {
      if (idx > this.list.length - 1) {
        idx = 0;
        resp.push(this.list[idx]);
        idx++;
      } else {
        resp.push(this.list[idx]);
        idx++;
      }

    }
    return resp;
  }
  /**
   *
   *
   * @param {*} idx indice desde donde iniciara la iteracion de manera descendente.
   * @returns Array de canales de manera descendente apartir de un indice.
   * @memberof ChannelList
   */
  getDataFromArrayDesc(idx) {
    let resp = [];
    if(this.list.length <= EpgConstants.TOTAL_ROWS_CHANNEL_GRID){
      return this.list;
    }else{
      // agregando el primer elemento
      resp.push(this.list[idx]);
      // agregando el resto de elementos
      while (resp.length <= this.quantity - 1) {
        if (idx >= this.list.length - 1) {
          idx = 0;
        } else {
          idx++;
        }
        resp.push(this.list[idx]);
      }
      return resp;
    }
  }

  /**
   *
   *
   * @param {*} loadObject Un canal a buscar
   * @returns El indice desde donde se encuentra el canal
   * @memberof ChannelList
   */
  getChannelIdxByGroupId(loadObject) {
    let result = this.list && Array.isArray(this.list) && this.list.findIndex(el => el.group_id === loadObject.group_id);
    if (result == -1) {
      result = 0;
    }
    return result;
  }

  /**
   *
   *
   * @returns El listado de todos los canales actuales.
   * @memberof ChannelList
   */
  getChannelList() {
    return this.list;
  }


  isGridIncomplete() {
    // Funcion usada para indicar que se tiene menos canales que el total de canales a pintar.
    if(this.list && Array.isArray(this.list) && this.list.length <= EpgConstants.TOTAL_ROWS_CHANNEL_GRID){
      return true;
    }
    return false;
  }




}

export default ChannelList;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/ChannelList.js